import { Typography } from "@mui/material";
import { MprcLink } from "components";
import { AssessmentType, NotificationType, TrainingType } from "generated/CoreApi_v1";
import { ReactNode } from "react";
import { Link } from "react-router";
import { LmsPaths } from "routes/LmsRouter";
import { AssPlayerEvaluation } from "views/assessment/player/AssPlayerEvaluation";
import { AssPlayerSurvey } from "views/assessment/player/AssPlayerSurvey";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";

////////////////////////////////////////////////////////////////////////////////

export class AssessmentResolver extends MessengerResolver {

    static messengerId: string[] = [
        "Ass.*",
    ];

    protected translateAction(): ReactNode {

        if (this.notificationActionKeys == null)
            return this.notificationAction?.title ?? "?";

        switch (this.notification.notificationTypeId) {
            case NotificationType.AssEssayPendingCorrection:
                return <Link to={LmsPaths.BuildListEssayCorrection(undefined, true)} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.AssInstanceFinishedEssayCorrection:
                return <Link to={`${LmsPaths.BuildEnrollmentViewer(TrainingType.Course, this.notificationActionKeys![0], this.notificationActionKeys![1])}`} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
                </Link>
                    ;

            case NotificationType.AssDeployReactionSurvey:
            case NotificationType.AssDeployEfficacySurvey:
            case NotificationType.AssDeployAnswerNewSurvey:
                return (
                    <MprcLink
                        color="primary.light"
                        onClick={
                            () => this.renderDialog(
                                <>
                                    {
                                        this.notificationActionKeys![3] == AssessmentType.Evaluation
                                            ?
                                            <AssPlayerEvaluation
                                                assessmentId={this.notificationActionKeys![2]}
                                                deployId={this.notificationActionKeys![0]}
                                                deployParticipantId={this.notificationActionKeys![1]}
                                                onClose={() => this.renderDialog(null)}
                                            />
                                            :
                                            <AssPlayerSurvey
                                                assessmentId={this.notificationActionKeys![2]}
                                                deployId={this.notificationActionKeys![0]}
                                                deployParticipantId={this.notificationActionKeys![1]}
                                                mode="play"
                                                onClose={() => this.renderDialog(null)}
                                            />
                                    }
                                </>
                            )
                        }
                    >
                        {this.notificationAction?.title}
                    </MprcLink>
                );
        }

        return "???";
    }
}
